import { IOfferCard } from '../../../types';

export function getClientFee(offerCard: IOfferCard): string {
  const fee = offerCard.bargainTerms.clientFee ? `комиссия ${offerCard.bargainTerms.clientFee}%` : 'без комиссии';

  return fee;
}
